import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content" style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
        <div className="footer-img-left" style={{marginRight:'2.2rem'}}>
          <img src={process.env.PUBLIC_URL + '/smart-platforms-ai-governance.png'} alt="Smart Platforms AI Governance" />
        </div>
        <div className="footer-main" style={{flex:'1', display:'flex', flexDirection:'column', alignItems:'center'}}>
          <div className="footer-logo-wrap" style={{marginBottom:'0.7rem'}}>
            <img src={process.env.PUBLIC_URL + '/WSO2 x Profesia logo-01.png'} alt="WSO2 x Profesia" style={{maxWidth:'320px', width:'100%', height:'auto', margin:'0 auto', display:'block'}} />
          </div>
          <div className="footer-company" style={{textAlign:'center', fontSize:'1.05rem', color:'#222', fontWeight:500, marginBottom:'0.2rem'}}>
            Profesia s.r.l. – Lynx Group
          </div>
          <div className="footer-contact" style={{textAlign:'center', fontSize:'1rem', color:'#4a7cff'}}>
            www.profesia.it - info@profesia.it
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
